(() => {
  const ID = 'ScCartConfirmation';
  let timer;

  function show(message = 'Item added to cart') {
    const toast = document.getElementById(ID);
    if (!toast) return;

    const text = toast.querySelector('[data-sc-cart-confirmation-text]');
    if (text) text.textContent = message;

    clearTimeout(timer);
    toast.hidden = false;

    requestAnimationFrame(() => {
      toast.classList.add('is-visible');
    });

    timer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => {
        if (!toast.classList.contains('is-visible')) toast.hidden = true;
      }, 220);
    }, 2200);
  }

  document.addEventListener('sc:cart-added', () => show());
})();
